import React from 'react';

type Props = {
    open: boolean;
    title?: string;
    scopes: string[];
    onClose: () => void;
};

export function ScopeModal({ open, title = 'Scopes', scopes, onClose }: Props) {
    if (!open) return null;
    return (
        <div className="modal" onClick={onClose}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <h2>{title}</h2>
                <div className="scroll-area">
                    {scopes.length === 0 ? (
                        <div className="feedback-message" style={{ background: 'transparent', textAlign: 'left', padding: 0 }}>
                            No scopes
                        </div>
                    ) : (
                        <div className="scopes">
                            {scopes.map(s => (
                                <span key={s} className="pill pill--scope">{s}</span>
                            ))}
                        </div>
                    )}
                </div>
                <div className="modal-actions">
                    <button className="btn-primary" type="button" onClick={onClose}>Close</button>
                </div>
            </div>
        </div>
    );
}
